import React from 'react';
import autoBind from 'react-autobind';
import debounce from 'lodash.debounce';
import MenuItem from 'material-ui/MenuItem';
import { geocodeByAddress, getLatLng } from './utils';
import AutoComplete from 'material-ui/AutoComplete';
import HelpToolTip from '../../components/HelpToolTip';
import style from './style';

export default class FieldLocation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      address: this.props.value,
      autocompleteItems: [],
      selected: false
    };

    autoBind(this);
    this.debouncedFetchPredictions = debounce(
      this.fetchPredictions,
      this.props.debounce
    );
  }

  componentDidMount() {
    if (!window.google) {
      throw new Error(
        'Google Maps JavaScript API library must be loaded. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library'
      );
    }

    if (!window.google.maps.places) {
      throw new Error(
        'Google Maps Places library must be loaded. Please add `libraries=places` to the src URL. See: https://github.com/kenny-hibino/react-places-autocomplete#load-google-library'
      );
    }

    this.autocompleteService = new window.google.maps.places.AutocompleteService();
    this.autocompleteOK = window.google.maps.places.PlacesServiceStatus.OK;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.address) {
      this.setState({ address: nextProps.value });
    }
  }

  autocompleteCallback(predictions, status) {
    this.clearAutocomplete();
    if (status !== this.autocompleteOK) {
      if (this.props.onError) {
        this.props.onError(status);
      }
      if (this.props.clearItemsOnError) {
        this.clearAutocomplete();
      }
      this.setState({
        autocompleteItems: [
          {
            value: <MenuItem primaryText="No results" disabled />,
            text: 'No results'
          }
        ]
      });
      return;
    }
    // transform snake_case to camelCase
    const formattedSuggestion = structuredFormatting => ({
      mainText: structuredFormatting.main_text,
      secondaryText: structuredFormatting.secondary_text
    });
    this.setState({
      autocompleteItems: predictions.map((p, idx) => {
        const { mainText, secondaryText } = formattedSuggestion(
          p.structured_formatting
        );
        const city = secondaryText.split(',')[0];
        return {
          text: p.description,
          value: (
            <MenuItem
              primaryText={mainText}
              secondaryText={city}
              onKeyUp={e => this.handleKeyUpSelect(e, p.description)}
            />
          )
        };
      })
    });
  }

  fetchPredictions() {
    const { address } = this.state;
    if (address.length) {
      this.autocompleteService.getPlacePredictions(
        {
          ...this.props.options,
          input: address
        },
        this.autocompleteCallback
      );
    }
  }

  clearAutocomplete() {
    this.setState({ autocompleteItems: [] });
  }

  selectAddress(address) {
    this.clearAutocomplete();
    this.handleSelect(address);
  }

  handleKeyUpSelect(e, mainText) {
    if (e.keyCode === 13) {
      this.handleSelect({ text: mainText });
    }
  }

  handleSelect(address) {
    if (address.text) {
      this.setState({
        address: address.text,
        selected: true
      });
      geocodeByAddress(address.text)
        .then(results => getLatLng(results[0]))
        .then(({ lat, lng }) => {
          if (this.props.addressName) {
            this.props.onChange({
              name: this.props.addressName,
              value: address.text
            });
          }
          if (this.props.geoName) {
            this.props.onChange({
              name: this.props.geoName,
              value: [lng, lat]
            });
          }
        })
        .catch(error => {
          if (this.props.onError) {
            this.props.onError(error);
          }
        });
    } else {
      this.setState({ address: '' });
    }
    this.clearAutocomplete();
  }

  handleInputChange(value) {
    if (!value) {
      this.clearAutocomplete();
      this.setState({ address: '', selected: false });
      return;
    }
    this.setState({ address: value, selected: false });
    this.debouncedFetchPredictions();
  }

  handleBlur(event) {
    if (!this.state.selected) {
      if (this.props.value) {
        this.setState({ address: this.props.value });
      } else {
        this.setState({ address: '' });
      }
    }
  }

  handleOnFocus() {
    this.setState({ selected: false });
  }

  render() {
    let { autocompleteItems, address } = this.state;
    let fieldProps = { ...this.props };
    delete fieldProps.addressName;
    delete fieldProps.geoName;
    delete fieldProps.geoValue;
    const { helpText, successText, ...props } = fieldProps;
    props.floatingLabelText = fieldProps.label;
    return (
      <div style={{ position: 'relative' }}>
        <AutoComplete
          {...props}
          fullWidth
          floatingLabelFixed
          filter={(searchText, key) => true}
          searchText={address}
          onNewRequest={this.handleSelect}
          dataSource={autocompleteItems}
          onUpdateInput={this.handleInputChange}
          onBlur={this.handleBlur}
          onFocus={this.handleOnFocus}
        />
        {this.props.tooltip && (
          <HelpToolTip
            style={{ position: 'absolute', left: 95, top: 12 }}
            tip={this.props.tooltip}
          />
        )}
        {helpText && <span style={style.helpText}>{helpText}</span>}
        {successText && <span style={style.successText}>{successText}</span>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldLocation/index.jsx